export const buildInfo = {
  buildVersion: '1.1.4',
  buildDate: 1612140763725,
  buildDateStr: 'Wed May 17 2023 10:00:00 GMT+0900 (Japan Standard Time)'
};
